export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/web.worker.0473d081.worker.js");
}
